import { InfoOutlined } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import { Button, Grid } from '@mui/material';
import { useState } from 'react';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import {
  FetchJobBoardCandidate,
  fetchJobBoardCandidate,
  ICandidate,
  ViewCvResponse,
} from 'wisestep-api';
import {
  formateDateInDateMonthYear,
  getDateDifferenceInMonths,
  ScrollableButtonTabs,
  WsColors,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

// import { useStatusActionPipelineContext } from '../../../context/StatusActionPipelineContext';

// import { useStatusActionPipelineContext } from '../../../context/StatusActionPipelineContext';
import { IBreadCrumbsList, WsBreadCrumbs } from '../../../components/WsBreadCrumbs';
import getDecodedQueryParams from '../../../utils/getDecodedQueryParams';
import { CandidateLayOutChildRoutes } from '../childRoutes';
import { useCandidateViewData } from '../utils/CandidateViewContext';
import { downloadCV, trackCV } from '../utils/cvHelper';
import { routeNames, RouteOptions, layoutTabNamesCrucible } from '../utils/helper';

import { TopBanner } from './childComponets';
import BottomBar from './childComponets/bottomBar';
import { MergeCandidate } from './mergeCandidate';

const CandidateLayout = () => {
  const navigate = useNavigate();
  const currentLocation = useLocation();
  const [openJobSelection, setOpenJobSelection] = useState<boolean>(false);
  const [openConvoWidgetFlag, setOpenConvoWidgetFlag] = useState<boolean>(false);
  const [submissionPurpose, setSubmissionPurpose] = useState<string>('');
  const [mappingPurpose, setMappingPurpose] = useState<string>('');
  const [mergeCandidateData, setMergeCandidateData] = useState<ViewCvResponse>({});
  const [open, setOpen] = useState(false);
  const [hideLatestCv, setHideLatestCv] = useState(true);

  const [params] = useSearchParams();
  const queryParams = params.get('q') ? getDecodedQueryParams(params.get('q') ?? '') : {};

  const selectedIndex = (index: number) => {
    navigate(
      `${routeNames[index]}?id=${params.get('id')}&array=${params.get('array')}${
        params.get('q') ? `&q=${params.get('q')}` : ''
      }${
        params.get('backwardpathArray')
          ? `&backwardpathArray=${params.get('backwardpathArray')}`
          : ''
      }`
    );
  };
  const { candidateViewData } = useCandidateViewData();
  // const loggedInUser = useUserContext().userDTO as IUserDTO;
  const backwardpath: IBreadCrumbsList[] = (
    params.get('backwardpathArray')
      ? getDecodedQueryParams(params.get('backwardpathArray') ?? '')
      : [{ label: 'Talent Pool', url: '/candidates' }]
  ) as IBreadCrumbsList[];
  const resumeUpdatedOnJobBoard = candidateViewData?.dateResumeLastUpdatedOnJobBoard
    ? getDateDifferenceInMonths(
        queryParams?.['resumeUpdatedOn'] ?? '',
        candidateViewData?.dateResumeLastUpdatedOnJobBoard ?? ''
      ) >= 3
    : false;
  const showGetLatestCV = queryParams?.['jobBoardId'] != null ? resumeUpdatedOnJobBoard : false;
  // const statusActionPipeline = useStatusActionPipelineContext();
  const isInDnc: boolean =
    (candidateViewData?.dnc?.isDeleted ?? false) || (candidateViewData?.dnc?.isInDnc ?? false);
  // const statusActionPipeline = useStatusActionPipelineContext();
  const [openConversationWidget, setOpenConversationWidget] = useState(false);
  const tabsWithCounts = layoutTabNamesCrucible.map((tab) => {
    switch (tab.tabName) {
      case 'Mappings':
        return {
          tabName: `${tab.tabName} (${candidateViewData?.mappingCount || 0})`,
        };
      case 'Submissions':
        return {
          tabName: `${tab.tabName} (${candidateViewData?.submissionCount || 0})`,
        };

      default:
        return tab;
    }
  });
  // const conversationStateValue: IConversationState = useMemo(() => {
  //   return {
  //     candidate: candidateViewData?.aggregationData?.jobInteraction
  //       ? candidateViewData?.aggregationData?.jobInteraction
  //       : candidateViewData?,
  //     currentUser: loggedInUser,
  //     candidateLocation: null,
  //     candidatePreferredLocations: [],
  //     recentJobMappings: [],
  //     autoSaveDisabledSettings: null,
  //     autoSaveAllowed: true,
  //     getDailyConversationCount: null,
  //     totalConversationPermanentCount: null,
  //     messageAndInteractionPipeline: statusActionPipeline,
  //   };
  // }, [
  //   candidateViewData?.aggregationData?.jobInteraction,
  //   candidateViewData?,
  //   loggedInUser,
  //   statusActionPipeline,
  // ]);

  const fetchLatestCV = async () => {
    const reqObj: FetchJobBoardCandidate = {
      jobBoardAccountId: params.get('accountId') ?? queryParams?.['accountId'] ?? '',
      jobBoardId: params.get('jobBoardId') ?? queryParams?.['jobBoardId'] ?? '',
      force: true,
      harvestingId: '',
      searchType: params.get('searchType') ?? queryParams?.['searchType'] ?? '',
      candidateData: candidateViewData as ICandidate,
    };
    const response = await fetchJobBoardCandidate(reqObj);
    if (response) {
      trackCV('download', response.newCandidateData?.resume?.resumeLocation);
      downloadCV(
        response.newCandidateData?.resume?.resumeLocation.split('?')[0],
        response.newCandidateData?.resume?.resumeFileName
      );
    }
    if (response?.fields?.length > 0) {
      setMergeCandidateData(response);
      setOpen(true);
    }
  };
  const breadCrumbsList: IBreadCrumbsList[] = [
    ...backwardpath,
    {
      label: candidateViewData?.name?.trim() || 'candidate',
      url: `${window.location.pathname}${window.location.search}`,
    },
  ];

  return (
    <Grid container height="100%" id="candidateViewContainer">
      <Grid item xs={12}>
        <WsBreadCrumbs breadCrumbsList={breadCrumbsList} />
      </Grid>
      <Grid item xs={12} id="candiateViewHeader" zIndex={1} mb={1}>
        <TopBanner
          setOpenConvoWidget={setOpenConversationWidget}
          setOpenJobSelection={setOpenJobSelection}
          setOpenConvoWidgetFlag={setOpenConvoWidgetFlag}
          setSubmissionPurpose={setSubmissionPurpose}
          setMappingPurpose={setMappingPurpose}
        />
      </Grid>
      {showGetLatestCV && hideLatestCv && (
        <Grid
          container
          alignItems="center"
          borderRadius={2}
          bgcolor={WsColors.Yellow100}
          p={2}
          rowGap={0.5}
          mb={1}
          sx={{ width: '100%', border: '1px solid #F8D372' }}
        >
          <Grid xs={6} container gap={1}>
            <InfoOutlined sx={{ color: WsColors.Yellow600 }} />
            <WsTypography
              variant={WsTypoVariants.SUB_TITLE}
              color={WsTypoColors.YELLOWDARK}
              bold={true}
            >
              {'Download Candidate Updated CV'}
            </WsTypography>
          </Grid>
          <Grid container justifyContent="flex-end" alignItems="center" gap={1} item xs={6}>
            <WsTypography variant={WsTypoVariants.SUB_TITLE} color={WsTypoColors.YELLOWDARK}>
              {`Latest CV Available - ${queryParams?.['jobBoard'] ?? ''}, 
              ${formateDateInDateMonthYear(queryParams?.['resumeUpdatedOn'] ?? '')}`}
            </WsTypography>
            <Button
              variant="contained"
              style={{ backgroundColor: WsColors.Yellow600, color: WsColors.White }}
              onClick={fetchLatestCV}
            >
              Download Updated CV
            </Button>
            <CloseIcon
              sx={{
                cursor: 'pointer',
                color: WsColors.GreyBlack,
              }}
              fontSize={'small'}
              onClick={() => setHideLatestCv(false)}
            />
          </Grid>
        </Grid>
      )}
      {mergeCandidateData?.fields?.length && (
        <MergeCandidate
          open={open}
          onClose={() => {
            setOpen(false);
          }}
          candidate={mergeCandidateData?.currentData ?? (candidateViewData as ICandidate)}
          fields={mergeCandidateData?.fields ?? []}
          mergeCandidate={mergeCandidateData?.newCandidateData ?? ({} as ICandidate)}
        />
      )}
      <Grid
        item
        xs={12}
        height="35%"
        borderRadius={2}
        sx={{ background: WsColors.White }}
        id="candiateViewScrollable"
        mb={0.5}
      >
        <ScrollableButtonTabs
          scrollList={tabsWithCounts}
          getTabIndex={selectedIndex}
          defaultValue={routeNames.indexOf(currentLocation.pathname.split('/')[2] as RouteOptions)}
        />
      </Grid>
      <Grid item xs={12} height="100%" id="candiateViewBody">
        <CandidateLayOutChildRoutes />
      </Grid>
      {!isInDnc && (
        <Grid
          item
          xs={12}
          display="flex"
          justifyContent="center"
          alignContent="center"
          alignItems="center"
        >
          {candidateViewData && (
            <BottomBar
              openConvoWidgetFlag={openConvoWidgetFlag}
              setOpenConvoWidgetFlag={setOpenConvoWidgetFlag}
              candidate={candidateViewData}
              // state={conversationStateValue}
              openConvoWidget={openConversationWidget}
              setOpenConvoWidget={setOpenConversationWidget}
              closeMap={() => {
                setOpenConversationWidget(false);
                selectedIndex(1);
              }}
              openJobSelection={openJobSelection}
              setOpenJobSelection={setOpenJobSelection}
              setSubmissionPurpose={setSubmissionPurpose}
              submissionPurpose={submissionPurpose}
              setMappingPurpose={setMappingPurpose}
              mappingPurpose={mappingPurpose}
            />
          )}
        </Grid>
      )}
    </Grid>
  );
};
export default CandidateLayout;
